import { configureApiClient } from '@repo/api/api-client';
import { setDefaultOptions } from 'date-fns';

import '@/styles/global.css';
import '@/api/axiosInterceptors';
import '@/ServiceWorketRegister';

import { pl } from 'date-fns/locale';
import { createRoot } from 'react-dom/client';

import App from '@/app/App';

configureApiClient({
  baseURL: import.meta.env.VITE_API_DOMAIN,
});

setDefaultOptions({
  locale: pl, // Default locale to Polish
  weekStartsOn: 1, // Week starts on Monday
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
